// HomeStat.js
// A single labeled number used inside week/summary strips, with an optional
// green delta shown next to the value.
import React from "react";
import { View, Text, StyleSheet } from "react-native";

import { HOME, homeColors } from "../homeTheme";

const HomeStat = ({ value, label, delta = null, isDarkMode = false }) => {
  const colors = homeColors(isDarkMode);

  return (
    <View style={styles.wrap}>
      <View style={styles.valueRow}>
        <Text style={[styles.value, { color: colors.textPrimary }]}>{value}</Text>
        {delta ? (
          <Text style={[styles.delta, { color: colors.green }]}>{delta}</Text>
        ) : null}
      </View>
      <Text style={[styles.label, { color: colors.textSecondary }]}>{label}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: { minWidth: 64 },
  valueRow: { flexDirection: "row", alignItems: "baseline", gap: 6 },
  value: {
    fontSize: HOME.statSize,
    fontWeight: "700",
    fontVariant: ["tabular-nums"],
  },
  delta: { fontSize: 12.5, fontWeight: "700" },
  label: { fontSize: 12.5, marginTop: 2 },
});

export default HomeStat;
